import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../../shared/product';
import { MarketingType, PersonaType } from '../../product-details-v2.interface';

@Component({
  selector: 'store-product-requirements',
  templateUrl: './app-product-requirements.component.html',
  styleUrls: ['./app-product-requirements.component.scss'],
  standalone: false,
})
export class AppProductRequirementsComponent implements OnInit {
  @Input() product: Product;
  @Input() businessCountryCode: string;
  @Input() marketingType: MarketingType = MarketingType.Partner;
  @Input() personaType: PersonaType = PersonaType.Partner;
  @Input() partnerId: string;
  @Input() marketId: string;

  showProductRequirementsPopover = false;
  hasProductDependencies: boolean;

  MarketingType = MarketingType;
  PersonaType = PersonaType;

  ngOnInit(): void {
    const appRequirementRules = this.product.restrictions?.appRequirement?.rules ?? [];
    this.hasProductDependencies =
      appRequirementRules[0]?.appIds?.length > 0 || appRequirementRules[0]?.requiredEditions?.length > 0;
  }
}
